import React from 'react';
import { createSvgIcon } from '../../utils/createSvgIcon';

export const SandClock = createSvgIcon(
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_2074_7797)">
      <path d="M19 16L28 28H4L13 16L4 4H28L19 16ZM16 16L23 6H9L16 16Z" fill="currentColor" />
    </g>
    <defs>
      <clipPath id="clip0_2074_7797">
        <rect width="32" height="32" fill="white" />
      </clipPath>
    </defs>
  </svg>,
  'SandClock'
);
